import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { HttpService } from 'src/service/http.service';
import Swal from 'sweetalert2';
import * as CryptoJS from "crypto-js";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  tokenFromUI: string = "17eba9787a50e18b23d3";

  ngOnInit(): void {
    
  }
model: any = {};
  fieldTextType: boolean;
  fieldTextType1: boolean;
  show: boolean = true;
  submitLoader: boolean = true;
  constructor(
    private _httpservice:HttpService,
    private _router:Router,
    private authGuard:AuthGuard
    ) { 
      this.authGuard.checkIdStatus();
    }


  onResetPassword(form: NgForm) {
    if (form.valid) {
    
    var userID=localStorage.getItem('uuid');
    let ciphertext = CryptoJS.AES.encrypt(form.value.password, this.tokenFromUI).toString();

    var passwordObj={
      // password:form.value.password,
      // user_verify:1,
      // user_id:userID
      "email": localStorage.getItem('email'),
      "password":ciphertext
    }
    this._httpservice.changePassword(passwordObj).subscribe(res => {
      Swal.fire({
    
        html: `<h5 class="sub-head">Password changed Successfully taking you to Login screen.</h5>`,
              
        icon: 'success',
        confirmButtonText: 'OK',
            customClass: {
              container: 'my-swal',
              confirmButton: 'your-confirm-button-class',

            }
      }).then((result) => {
        // this.router.navigate(['otp'])
        // this._router.navigate(['sign-in'])
        if(res.responseCode === 0){
          this._router.navigate(['sign-in'])
        }

      });
      localStorage.clear();
    });
  }
  }
  // password has been changed sucessfully and re-login with new password
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  toggleFieldTextType1() {
    this.fieldTextType1 = !this.fieldTextType1;
  }
}
